import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DiscountListing = _resolveComponent("DiscountListing")!
  const _component_AddDiscount = _resolveComponent("AddDiscount")!
  const _component_EditDiscount = _resolveComponent("EditDiscount")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DiscountListing, { discount_type: 'ORDER_DISCOUNT' }),
    _createVNode(_component_AddDiscount, { discount_type: _ctx.discount_type }, null, 8, ["discount_type"]),
    _createVNode(_component_EditDiscount, { discount_type: _ctx.discount_type }, null, 8, ["discount_type"])
  ], 64))
}